import { Box, Hidden } from '@mui/material'
import WrapperPermission from 'components/wrapper-permission'
import React, { ReactNode } from 'react'
import { useStyles } from './style'

type Props = {
  title: string
  subTitle?: string
  banner: ReactNode
}

const ImageBanner: React.FC<Props> = ({ title, banner, subTitle = '' }: Props) => {
  const classes = useStyles()

  return (
    <Hidden lgDown>
      <WrapperPermission withBackground>
        <Box className={classes.root}>
          <h1 className={classes.title}>{title}</h1>
          <h4 className={classes.subtitle}>{subTitle}</h4>

          <Box className={classes.image}>{banner}</Box>
        </Box>
      </WrapperPermission>
    </Hidden>
  )
}

export default ImageBanner
